import { useSearchParams, useLocation } from 'react-router-dom'
import { getDefaultPhaseForRoute } from '@/lib/route-phase-map'

/**
 * Resolves the current workflow phase.
 * Priority 1: explicit ?phase=N from URL (Dashboard navigation)
 * Priority 2: inferred from route pathname mapping
 * Returns null when the stepper should not be shown.
 */
export function useCurrentPhase(): number | null {
  const [searchParams] = useSearchParams()
  const { pathname } = useLocation()

  const phaseParam = searchParams.get('phase')
  if (phaseParam) {
    const n = parseInt(phaseParam, 10)
    if (n >= 1 && n <= 8) return n
  }

  return getDefaultPhaseForRoute(pathname)
}
